import * as Sentry from "@sentry/react";

export const sendSentryException = data => {
    (process.env.NODE_ENV === "production" ||
        process.env.NODE_ENV === "beta") &&
        Sentry.captureException(data);
    return;
};
